package com.techspiration.webuserapp.legal

import androidx.compose.runtime.Composable
import com.techspiration.webuserapp.site.SectionContainer
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/**
 * Gizlilik Politikası — App Store Connect "Privacy Policy" alanı ve uygulama içi abonelik
 * ekranından (Guideline 3.1.2(c)) referans verilen sayfa. Gerçek DOM (Compose HTML) → metin
 * seçilebilir, arama motorları indeksleyebilir, ekran okuyucular erişebilir.
 */
@Composable
fun PrivacyScreen() {
    SectionContainer {
        H1(attrs = { classes("t-h1") }) { Text("Gizlilik Politikası") }
        P(attrs = { classes("t-label") }) { Text("Son güncelleme: 16 Haziran 2026") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Bu politika, KamuApp (Atama Bildirim — Kamu İlanları) uygulamasının Techspiration " +
                    "tarafından işletilen veri işleme süreçlerini kapsar; KVKK ve GDPR gerekliliklerine uyumludur.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Toplanan Veriler") }
        Ul {
            Li { Text("Hesap bilgileri: e-posta, ad-soyad, şifre (bcrypt ile şifrelenmiş/hash'lenmiş olarak saklanır).") }
            Li { Text("Profil bilgileri: eğitim durumu, sınav puanları, kariyer ilgi alanları (ilan eşleştirme için).") }
            Li { Text("Cihaz bilgileri: işletim sistemi, uygulama sürümü, Firebase üzerinden analitik veriler.") }
            Li { Text("Uygulama konum, kamera, rehber veya mikrofon erişimi TALEP ETMEZ ve KULLANMAZ.") }
        }

        H2(attrs = { classes("t-h2") }) { Text("Verilerin Kullanım Amacı") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Toplanan veriler kimlik doğrulama, ilan listesi kişiselleştirme, bildirimler, analitik, " +
                    "güvenlik önlemleri ve (ücretsiz sürümde) reklam gösterimi amacıyla kullanılır.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Üçüncü Taraflarla Paylaşım") }
        P(attrs = { classes("t-body") }) { Text("Verileriniz satılmaz. Uygulamanın çalışması için sınırlı paylaşım şu taraflarla yapılır:") }
        Ul {
            Li { Text("Google (Firebase, AdMob, Play Billing)") }
            Li { Text("Apple App Store") }
            Li { Text("GeoIP servis sağlayıcıları") }
        }

        H2(attrs = { classes("t-h2") }) { Text("İlan Kaynakları") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Kamu ilanları yalnızca Kariyer Kapısı ve İŞKUR (Türkiye İş Kurumu) gibi resmi devlet " +
                    "platformlarından derlenir. Uygulama bu kurumlardan bağımsızdır ve bu kurumlarla iştirak ilişkisi yoktur.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Kullanıcı Hakları") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Kişisel verilerinize uygulama içi ayarlar veya kamuapp@techspiration.me adresinden " +
                    "erişebilir, düzeltebilir veya silinmesini talep edebilirsiniz. Hesap silme talebi sonrası " +
                    "verileriniz makul bir süre içinde kaldırılır.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("İletişim") }
        P(attrs = { classes("t-body") }) { Text("Sorularınız için: kamuapp@techspiration.me") }
    }
}
